import { dayNumberInData } from "../functions";
import { mean } from "mathjs";
import type {
  AnnualConst,
  CalcOptions,
  DaySettingsData,
} from "../algorithm.types";

type CalculateAverageDemandParams = {
  calcOptions: Pick<
    CalcOptions,
    "season" | "dayOfTheSeason" | "noOfDaysPerSeason"
  >;
  daySettingsData: DaySettingsData;
  annualConst: Pick<AnnualConst, "averageDemandPerDay">;
};

export default function calculateAverageDemand({
  calcOptions,
  daySettingsData,
  annualConst,
}: CalculateAverageDemandParams): Array<number> {
  const { season, dayOfTheSeason, noOfDaysPerSeason } = calcOptions;

  annualConst.averageDemandPerDay[
    dayNumberInData(season, dayOfTheSeason, noOfDaysPerSeason)
  ] = mean(
    daySettingsData[
      dayNumberInData(season, dayOfTheSeason, noOfDaysPerSeason)
    ][0],
  );

  return annualConst.averageDemandPerDay;
}
